import { MainFooterMobile } from "../../main/mobile/MainFooterMobile";
import { MainGnbMobile } from "../../main/mobile/MainGnbMobile";
import { MainLayout } from "../../main/pc/MainLayout";
import { AboutContentsMobile } from "./AboutContentsMobile";

const AboutPageMobile = () => (
	<MainLayout>
		<MainGnbMobile type="none" />
		<AboutContentsMobile />
		<MainFooterMobile />
	</MainLayout>
);

export default AboutPageMobile;
